import React from 'react';

export const Asterisk = () => {
    return <sup className='text-[#26818E] top-[-3px]'>*</sup>
}
